import React from "react";
import MainPage from "./pages/main-page";
import HeaderPage from "./pages/header-page";

function App() {
    return (
        <>
            <HeaderPage />
            <MainPage />
        </>
    );
}

export default App;